export const LOADING_PAGE_PUNS =  [
  "All bees-ness here as we load your details",
  "Hive five! Buzzing into your account now",
  "You better bee-lieve we are excited to be logging you in",
  "Making a bee-line to your account",
  "Winging it! Joking, all orga-hived here and logging you in",
  "The bees knees of apps coming your way"
]

export const LOGGING_OUT_PAGE_PUNS =  [
  "Swarm wishes till we meet again!",
  "Had an un-bee-lievable time with you!",
  "Well, I’ll bee! That was fun!",
  "Wasp! Leaving already!",
  "Bee cool!",
  "Hive had a blast!",
]
